import type { Theme, WithStyles } from "@envestnet/envreact-component-library";
import { createStyles } from "@envestnet/envreact-component-library";

const styles = (theme: Theme) =>
  createStyles({
    container: {},
    orderedListClass: {
      marginTop: 32,
      marginBottom: 32,
      paddingLeft: 18,
      "& > li": {
        ...theme.fonts.p2,
        color: theme.colors.textDefault,
        textAlign: "left",
        marginBottom: 16,
      },
    },
    warningContainer: {
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
    },
    warningText: {
      ...theme.fonts.p2,
      color: theme.colors.textDefault,
    },
    linkButtonClass: {
      marginTop: 32,
      paddingLeft: 0,
      float: "left",
    },
    nextButtonClass: {
      width: "100%",
      marginTop: 32,
    },
  });

export type Styles = WithStyles<typeof styles>;
export default styles;
